import { To, useMatch, useResolvedPath } from 'react-router-dom';

const useIsCurrentPath = (path: To) => {
  const resolved = useResolvedPath(path);
  return Boolean(useMatch({ path: resolved.pathname, end: true }));
};

export default useIsCurrentPath;
